import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { useApi } from '@fortem-monorepo/react-spa'
import { Premialab } from '@fortem-monorepo/web-sdk'

export const useSubmitDailyCompositionMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (body: Premialab.PostDailyCompositionTemplateBody) => {
      return api.premialab.postDailyComposition(body)
    },
    onSuccess: (_data, _params) => {
      toast.success('Daily Composition submitted')
    },
  })
}

export const useUploadToSFTPMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (body: Premialab.UploadDailyCompositionBody) => {
      return api.premialab.uploadDailyComposition(body)
    },
    onSuccess: (_data, _params) => {
      toast.success('Upload successful')
    },
  })
}
